module.exports = __webpack_public_path__ + "img/shape7.dee09957.png";